import React from 'react';
import { ClockIcon, UsersIcon, DollarSignIcon, Award } from 'lucide-react';
export const ProblemSection = () => {
  return <section className="py-24 md:py-32 bg-white relative z-10" data-id="element-159">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl" data-id="element-160">
        <div className="text-center mb-16 md:mb-20" data-id="element-161">
          <h2 className="text-4xl md:text-5xl font-semibold mb-4 tracking-tight text-[#111928]" data-id="element-162">
            The Problem
          </h2>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-163">
          {/* Content */}
          <div className="space-y-8" data-id="element-164">
            <div className="flex gap-4 group" data-id="element-165">
              <div className="flex-shrink-0 mt-1" data-id="element-166">
                <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-167">
                  <UsersIcon className="w-6 h-6 text-[#186447] group-hover:text-white transition-colors" strokeWidth={1.5} data-id="element-168" />
                </div>
              </div>
              <div data-id="element-169">
                <h4 className="text-lg md:text-xl font-bold text-[#111928] mb-2" data-id="element-170">
                  Clients Need Expert Guidance
                </h4>
                <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-171">
                  Clients want neutral, tailored advice from experts to cut
                  through the noise.
                </p>
              </div>
            </div>{' '}
            <div className="flex gap-4 group" data-id="element-172">
              <div className="flex-shrink-0 mt-1" data-id="element-173">
                <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-174">
                  <DollarSignIcon className="w-6 h-6 text-[#186447] group-hover:text-white transition-colors" strokeWidth={1.5} data-id="element-175" />
                </div>
              </div>
              <div data-id="element-176">
                <h4 className="text-lg md:text-xl font-bold text-[#111928] mb-2" data-id="element-177">
                  Limited Revenue Streams
                </h4>
                <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-178">
                  As an aesthetics professional, your earning potential is tied
                  to in-chair appointments.
                </p>
              </div>
            </div>{' '}
            <div className="flex gap-4 group" data-id="element-179">
              <div className="flex-shrink-0 mt-1" data-id="element-180">
                <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-181">
                  <ClockIcon className="w-6 h-6 text-[#186447] group-hover:text-white transition-colors" strokeWidth={1.5} data-id="element-182" />
                </div>
              </div>
              <div data-id="element-183">
                <h4 className="text-lg md:text-xl font-bold text-[#111928] mb-2" data-id="element-184">
                  Time-Intensive Consultations
                </h4>
                <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-185">
                  Virtual video consults are time-intensive with uncertain ROI.
                </p>
              </div>{' '}
            </div>
          </div>
        </div>
      </div>
    </section>;
};